import clsx from 'clsx';
import { StockLabelTone } from '~/lib/salesforce/utilities/product-stock';
import styles from './ProductStockLabel.module.scss';

type Props = {
    tone: StockLabelTone;
    children: React.ReactNode;
    className?: string;
};

export const ProductStockLabel: React.FC<Props> = ({ tone, children, className }) => (
    <span className={clsx(styles.stockLabel, className)}>
        <span className={clsx(styles.icon, styles[`color-${tone}`])} />

        {children}
    </span>
);
